const dodatkiArr = [
  ['Dodatkowy sos', [], ['2', '00'], 1],
  ['Dodatkowy ser', [], ['2', '00'], 2],
  ['Dodatkowe warzywa', [], ['3', '00'], 3],
  ['Dodatkowe mięso', [], ['10', '00'], 4],
]

export default dodatkiArr
